import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from '@mui/material';
import { getUserFullName } from '../../utils/user.utils';
import { Autocomplete, TextField } from '@mui/material';

export const UpdateUserGroupModal = ({
    show,
    handleClose,
    lngsltd,
    editUserIDs,
    setEditUserIDs,
    userData,
    editGroupIDs,
    setEditGroupIDs,
    groupData,
    handleUpdate
}) => {

    const handleGroupChange = (event) => {
        const {
            target: { value },
        } = event;

        setEditGroupIDs(
            typeof value === 'string'
                ? value.split(',').map(Number)
                : value
        );
    };

    return (
        <Dialog open={show} onClose={handleClose} fullWidth>
            <DialogTitle style={{ backgroundColor: '#efedf0' }}>
                {lngsltd["Update details"]}
            </DialogTitle>

            <DialogContent>

                {/* USER SELECT */}
                <FormControl fullWidth margin="normal" required>
                    <Autocomplete
                        multiple
                        options={userData}
                        getOptionLabel={(option) => getUserFullName(option)}
                        value={userData.filter(u => editUserIDs.includes(u.userID))}
                        onChange={(e, value) => setEditUserIDs(value.map(v => v.userID))}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={lngsltd["Select Users"]}
                                placeholder="Select Users"
                            />
                        )}
                    />
                </FormControl>

                {/* GROUP SELECT */}
                <FormControl fullWidth margin="normal" required>
                    <InputLabel>{lngsltd["Select Groups"]}</InputLabel>
                    <Select
                        multiple
                        value={editGroupIDs || []}
                        onChange={handleGroupChange}
                        label={lngsltd["Select Groups"]}
                        renderValue={(selected) =>
                            selected
                                .map(id =>
                                    groupData.find(g => g.groupID === id)?.groupName
                                )
                                .filter(Boolean)
                                .join(', ')
                        }
                    >
                        {groupData.map((group) => (
                            <MenuItem
                                key={group.groupID}
                                value={group.groupID}  // number
                            >
                                <Checkbox
                                    checked={editGroupIDs?.includes(group.groupID)}
                                />
                                <ListItemText primary={group.groupName} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

            </DialogContent>

            <DialogActions>
                <Button variant="contained" onClick={handleUpdate}>
                    {lngsltd["Save"]}
                </Button>
                <Button variant="outlined" color="error" onClick={handleClose}>
                    {lngsltd["Cancel"]}
                </Button>
            </DialogActions>
        </Dialog>
    );

}
